/*  MUI  */
import { Box, Tab } from '@mui/material';

/* Shared */
import { PageTitle } from 'application/Shared/Components/App';
import { MUITabsWrapper } from 'application/Shared/Components/MUITabsWrapper';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router';

export const SetupReportViewHeaderTabs = ({
    reportType,
    qbrToCBR // Feature flag to show "CBR" (Customer Business Review) instead of "QBR" (Quarterly Business Report) when enabled
}) => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const urlTab = searchParams.get('tab');
    const currentTab = urlTab || 'reportSetup';

    const getTitle = () => {
        if (currentTab === 'myReports') {
            return t('Reports.my_reports');
        }

        if (!reportType) {
            return t('Reports.report_setup');
        }

        return reportType === 'qbr' && qbrToCBR
            ? t('Common.cbr')
            : t(`Reports.Title.${reportType}.report`);
    };

    return (
        <Box data-trackid="setupReportViewHeaderTabs">
            <Box>
                <PageTitle title={getTitle()} />
            </Box>

            <Box>
                <MUITabsWrapper value={currentTab}>
                    <Tab
                        component={Link}
                        to="?tab=reportSetup"
                        value="reportSetup"
                        label={t('Reports.report_setup')}
                        aria-label="report-setup"
                        data-trackid="reports_reportSetup"
                    />
                    <Tab
                        component={Link}
                        to="?tab=myReports"
                        value="myReports"
                        label={t('Reports.my_reports')}
                        aria-label="scheduled-reports"
                        data-trackid="reports_scheduledReports"
                    />
                </MUITabsWrapper>
            </Box>
        </Box>
    );
};
